var _rect, _rect2, _rect3, _rect4, _rect5, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerticalHmi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 55,
    viewBox: "0 0 116 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 54,
    rx: 2.5,
    stroke: "#CDD0D4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 31,
    height: 2,
    rx: 1,
    fill: "#CDD0D4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 27,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#CDD0D4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 34,
    width: 25,
    height: 2,
    rx: 1,
    fill: "#CDD0D4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 0.5,
    width: 55,
    height: 54,
    rx: 2.5,
    stroke: "#CDD0D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.5996 28.744H77.1756V33H75.5936V23.228H77.1756V27.344H81.5996V23.228H83.1816V33H81.5996V28.744ZM93.0638 25.524H92.9938L92.2238 27.106L90.0818 31.012L87.9398 27.106L87.1698 25.524H87.0998V33H85.5878V23.228H87.4638L90.0818 28.198H90.1658L92.7838 23.228H94.5758V33H93.0638V25.524ZM96.5701 33V31.712H97.9001V24.516H96.5701V23.228H100.826V24.516H99.4821V31.712H100.826V33H96.5701Z",
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalHmi);
export default __webpack_public_path__ + "static/media/verticalHmi.555858ca70e5d93bdb393023607e653e.svg";
export { ForwardRef as ReactComponent };